import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedMatchProgramService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getProgram(departmentType) {
        const body = this.setBody();
        body.set('departmentType', departmentType);
        return this.http.post(this.urlService + this.routeAdress.route_tournament_program_now, body.toString()).pipe(
            map(this.extractData),
            map((response) => {
                if (!response.registers) return response;
                // const { 1: first = {}, 2: second = {} } = response.registers.list;
                // const firstList = Object.values(first);
                // const secondList = Object.values(second);
                const list = Object.values(response.registers.list);

                return {
                    ...response,
                    registers: {
                        ...response.registers,
                        list,
                    },
                };
            }),
            catchError(this.serviceError)
        );
    }
}

const MOCK = {
    vip: {
        id_jogo: '1044030',
        id_jogo_detalhe: '1046820',
        torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
        nome_categoria: '12 Anos Feminino Simples',
        dt_jogo: '12/05/2021',
        hr_jogo: '00:00',
        participantes: {
            '1': [
                {
                    id_site: '237583',
                    url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id237583/fotos/avatar.jpg',
                    nome: 'Lara Marinho',
                },
            ],
            '2': [
                {
                    id_site: '233093',
                    url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id233093/fotos/avatar.jpg',
                    nome: 'Isabela Hackradt',
                },
            ],
        },
        h2h: {
            label: 'Probabilidade de vitória (%)',
            perform: {
                total: 100,
                lado_1: 75,
                lado_2: 25,
            },
        },
    },
    list: {
        '1': [
            {
                id_jogo: '1043966',
                id_jogo_detalhe: '1046756',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '16 Anos Masculino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '227257',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id227257/fotos/avatar.jpg',
                            nome: 'Thiago Yukio',
                        },
                    ],
                    '2': [
                        {
                            id_site: '217949',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id217949/fotos/avatar.jpg',
                            nome: 'Eduardo Guenther',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 50,
                        lado_2: 50,
                    },
                },
            },
            {
                id_jogo: '1043968',
                id_jogo_detalhe: '1046758',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '16 Anos Masculino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '53801',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id53801/fotos/avatar.jpg',
                            nome: 'Pedro Fachin',
                        },
                    ],
                    '2': [
                        {
                            id_site: '47495',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id47495/fotos/avatar.jpg',
                            nome: 'Eric Martins',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 71,
                        lado_2: 29,
                    },
                },
            },
            {
                id_jogo: '1043998',
                id_jogo_detalhe: '1046788',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '18 Anos Masculino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '14:00',
                participantes: {
                    '1': [
                        {
                            id_site: '41296',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id41296/fotos/avatar.jpg',
                            nome: 'Daniel Rebelo',
                        },
                    ],
                    '2': [
                        {
                            id_site: '225920',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id225920/fotos/avatar.jpg',
                            nome: 'Bruno Granzotto',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 44,
                        lado_2: 56,
                    },
                },
            },
            {
                id_jogo: '1043972',
                id_jogo_detalhe: '1046762',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '16 Anos Masculino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '217948',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id217948/fotos/avatar.jpg',
                            nome: 'Gabriel Guenther',
                        },
                    ],
                    '2': [
                        {
                            id_site: '57824',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id57824/fotos/avatar.jpg',
                            nome: 'Paulo Sérgio Silva',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 50,
                        lado_2: 50,
                    },
                },
            },
            {
                id_jogo: '1044002',
                id_jogo_detalhe: '1046792',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '18 Anos Masculino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '48753',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id48753/fotos/avatar.jpg',
                            nome: 'Davi Savi',
                        },
                    ],
                    '2': [
                        {
                            id_site: '42751',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id42751/fotos/avatar.jpg',
                            nome: 'Victor Poy',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 50,
                        lado_2: 50,
                    },
                },
            },
        ],
        '2': {
            '1': {
                id_jogo: '1044030',
                id_jogo_detalhe: '1046820',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '12 Anos Feminino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '237583',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id237583/fotos/avatar.jpg',
                            nome: 'Lara Marinho',
                        },
                    ],
                    '2': [
                        {
                            id_site: '233093',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id233093/fotos/avatar.jpg',
                            nome: 'Isabela Hackradt',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 75,
                        lado_2: 25,
                    },
                },
            },
            '2': {
                id_jogo: '1044031',
                id_jogo_detalhe: '1046821',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '12 Anos Feminino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '233351',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id233351/fotos/avatar.jpg',
                            nome: 'Rafaela Teixeira',
                        },
                    ],
                    '2': [
                        {
                            id_site: '202205',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id202205/fotos/avatar.jpg',
                            nome: 'Maria Eduarda',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 27,
                        lado_2: 73,
                    },
                },
            },
            '3': {
                id_jogo: '1044033',
                id_jogo_detalhe: '1046823',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '12 Anos Feminino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '216147',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id216147/fotos/avatar.jpg',
                            nome: 'Victória Rauber',
                        },
                    ],
                    '2': [
                        {
                            id_site: '231630',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id231630/fotos/avatar.jpg',
                            nome: 'Ariana Caballero',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 11,
                        lado_2: 89,
                    },
                },
            },
            '4': {
                id_jogo: '1044033',
                id_jogo_detalhe: '1046823',
                torneio: 'INFANTO JUVENIL DE TÊNIS 2021 (ESTADUAL FCT)',
                nome_categoria: '12 Anos Feminino Simples',
                dt_jogo: '12/05/2021',
                hr_jogo: '00:00',
                participantes: {
                    '1': [
                        {
                            id_site: '216147',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id216147/fotos/avatar.jpg',
                            nome: 'Victória Rauber',
                        },
                    ],
                    '2': [
                        {
                            id_site: '231630',
                            url_avatar: 'https://testes.tenisintegrado.com.br/uploads/id231630/fotos/avatar.jpg',
                            nome: 'Ariana Caballero',
                        },
                    ],
                },
                h2h: {
                    label: 'Probabilidade de vitória (%)',
                    perform: {
                        total: 100,
                        lado_1: 11,
                        lado_2: 89,
                    },
                },
            },
        },
    },
};
